import React from 'react'

import ConnectorStatus from '../connector-status'
import findChargingConnector from '../findChargingConnector'
import findSchukoConnector from '../findSchukoConnector'
import isSchukoEnabled from '../isSchukoEnabled'
import isHalo from '../isHalo'
import { ChargePoint } from '../../common/redux/api/web-api'
import useText from '../../common/hooks/useText'

const ONLINE_STATUS = 'Online'

export type ChargepointStatusProps = {
    chargePoint: ChargePoint
}

export const ChargepointStatus = React.memo(function ChargepointStatus({
    chargePoint,
}: ChargepointStatusProps): React.ReactElement {
    const text = useText()
    const isOnline = chargePoint?.chargePointStatus === ONLINE_STATUS

    const checkIsSchukoEnabled = (chargePoint: ChargePoint) => {
        if (!chargePoint.isOcpp) return true

        return isSchukoEnabled(chargePoint)
    }

    return (
        <div>
            {isHalo(chargePoint) &&
                chargePoint.connectors &&
                (isOnline ? (
                    <span>
                        <ConnectorStatus
                            isOcpp={chargePoint.isOcpp}
                            connector={findChargingConnector(chargePoint.connectors)}
                            productId={chargePoint.productId}
                        />

                        {checkIsSchukoEnabled(chargePoint) && (
                            <ConnectorStatus
                                isOcpp={chargePoint.isOcpp}
                                connector={findSchukoConnector(chargePoint.connectors)}
                                productId={chargePoint.productId}
                            />
                        )}
                    </span>
                ) : (
                    <i className="pi pi-wifi text-red-500 mt-1" title={text('lblOffline')}></i>
                ))}
            {!isHalo(chargePoint) &&
                chargePoint?.connectors
                    ?.filter((connector) => !!connector)
                    .map((connector, index) => (
                        <div
                            key={`connector-${connector.connectorId}-${connector.name ?? 'unknown'}-${index}`}
                            className="p-1"
                        >
                            {isOnline ? (
                                <ConnectorStatus
                                    isOcpp={chargePoint.isOcpp}
                                    connector={connector}
                                    productId={chargePoint.productId}
                                />
                            ) : (
                                <i className="pi pi-wifi text-red-500 mt-1" title={text('lblOffline')}></i>
                            )}
                        </div>
                    ))}
        </div>
    )
})
